import axios from "axios";

import {
  reducerGetOutlets,
  reducerUnloadOutlets,
} from "../../reducer/easymerch/reducers/reducerOutlets";
import { AppDispatch } from "../../reducer/store";
import { getToken } from "../axiosToken";

const BASE_URL = process.env.REACT_APP_BASE_URL;

export const actionGetOutlets =
  (limit: number, offset: any) =>
  async (dispatch: AppDispatch, getState: () => any) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;

    const store = getState();
    const filter = store.easymerch.outlets.outletsInputValues;
     try {
      const response = await axios.post(`${BASE_URL}/json/em/pos/poses`, {
        limit,
        offset,
        contractType: 0,
        ...filter,
      });
  
      dispatch(reducerGetOutlets({ data: response.data, limit, offset: 0 }));
     } catch (e: any) {
      if (e.response.status === 401) {
        window.location.href = "/login";
      }
      }

  };

export const actionUnloadOutlets =
  (limit: number, offset: any, filter?: any) => async (dispatch: AppDispatch) => {
    const { token } = await getToken();
    axios.defaults.headers.common["Authorization"] = token;
    try {
      const response = await axios.post(`${BASE_URL}/json/em/pos/export`, {
        limit,
        offset,
        contractType: 0,
        ...filter,
      });

      dispatch(
        reducerUnloadOutlets({ data: response.data, status: response.status })
      );
    } catch (err) {
      dispatch(reducerUnloadOutlets({ data: {}, status: 0 }));
    }
  };
